/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M2 12L17 12M17 12L13 8M17 12L13 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 8L8 7.50003V7.50003C8 6.10444 8 5.40665 8.17225 4.83884C8.56005 3.56045 9.56045 2.56005 10.8388 2.17225C11.4066 2 12.1044 2 13.5 2L15.6 2C17.8402 2 18.9603 2 19.816 2.43597C20.5686 2.81947 21.1805 3.43139 21.564 4.18404C22 5.03969 22 6.15979 22 8.4L22 15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H13.5C12.1044 22 11.4067 22 10.8389 21.8278C9.56046 21.44 8.56003 20.4395 8.17223 19.1611C8 18.5933 8 17.8956 8 16.5V16.5L8 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="8"
				y="2"
				width="14"
				height="20"
				rx="4"
				fill="currentColor"
			/>
			<path
				d="M8 8L8 7.50003V7.50003C8 6.10444 8 5.40665 8.17225 4.83884C8.56005 3.56045 9.56045 2.56005 10.8388 2.17225C11.4066 2 12.1044 2 13.5 2L15.6 2C17.8402 2 18.9603 2 19.816 2.43597C20.5686 2.81947 21.1805 3.43139 21.564 4.18404C22 5.03969 22 6.15979 22 8.4L22 15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H13.5C12.1044 22 11.4067 22 10.8389 21.8278C9.56046 21.44 8.56003 20.4395 8.17223 19.1611C8 18.5933 8 17.8956 8 16.5V16.5L8 16M2 12H17M17 12L13 8M17 12L13 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.43404 1.68591C10.2897 1.24994 11.4098 1.24994 13.65 1.24994H16.35C18.5902 1.24994 19.7103 1.24994 20.566 1.68591C21.3186 2.06941 21.9305 2.68133 22.314 3.43398C22.75 4.28962 22.75 5.40973 22.75 7.64994V16.3499C22.75 18.5902 22.75 19.7103 22.314 20.5659C21.9305 21.3186 21.3186 21.9305 20.566 22.314C19.7103 22.7499 18.5902 22.7499 16.35 22.7499H13.65C11.4098 22.7499 10.2897 22.7499 9.43404 22.314C8.68139 21.9305 8.06947 21.3186 7.68597 20.5659C7.25 19.7103 7.25 18.5902 7.25 16.3499V12.75L15.1893 12.75L12.4697 15.4697C12.1768 15.7626 12.1768 16.2375 12.4697 16.5304C12.7626 16.8232 13.2374 16.8232 13.5303 16.5304L17.5303 12.5304C17.8232 12.2375 17.8232 11.7626 17.5303 11.4697L13.5303 7.46969C13.2374 7.1768 12.7626 7.1768 12.4697 7.46969C12.1768 7.76258 12.1768 8.23746 12.4697 8.53035L15.1893 11.25L7.25 11.25V7.64994C7.25 5.40973 7.25 4.28962 7.68597 3.43398C8.06947 2.68133 8.68139 2.06941 9.43404 1.68591ZM7.25 11.25H2C1.58579 11.25 1.25 11.5858 1.25 12C1.25 12.4142 1.58579 12.75 2 12.75H7.25V11.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M8 8L8 7.50003V7.50003C8 6.10444 8 5.40665 8.17225 4.83884C8.56005 3.56045 9.56045 2.56005 10.8388 2.17225C11.4066 2 12.1044 2 13.5 2L15.6 2C17.8402 2 18.9603 2 19.816 2.43597C20.5686 2.81947 21.1805 3.43139 21.564 4.18404C22 5.03969 22 6.15979 22 8.4V9.5L22 10M8 16L8 16.5V16.5C8 17.8956 8 18.5933 8.17223 19.1611C8.56003 20.4395 9.56046 21.44 10.8389 21.8278C11.4067 22 12.1044 22 13.5 22H15.6C17.8402 22 18.9603 22 19.816 21.564C20.5686 21.1805 21.1805 20.5686 21.564 19.816C22 18.9603 22 17.8402 22 15.6V14.5L22 14M2 12H17L13 8M14.5 14.5L13 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M8 8L8 7.50003V7.50003C8 6.10444 8 5.40665 8.17225 4.83884C8.56005 3.56045 9.56045 2.56005 10.8388 2.17225C11.4066 2 12.1044 2 13.5 2L15.6 2C17.8402 2 18.9603 2 19.816 2.43597C20.5686 2.81947 21.1805 3.43139 21.564 4.18404C22 5.03969 22 6.15979 22 8.4L22 15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H13.5C12.1044 22 11.4067 22 10.8389 21.8278C9.56046 21.44 8.56003 20.4395 8.17223 19.1611C8 18.5933 8 17.8956 8 16.5V16.5L8 16M2 12H17M17 12L13 8M17 12L13 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M13.65 1.25C11.4098 1.25 10.2897 1.25 9.43404 1.68597C8.68139 2.06947 8.06947 2.68139 7.68597 3.43404C7.25 4.28969 7.25 5.40979 7.25 7.65V16.35C7.25 18.5902 7.25 19.7103 7.68597 20.566C8.06947 21.3186 8.68139 21.9305 9.43404 22.314C10.2897 22.75 11.4098 22.75 13.65 22.75H16.35C18.5902 22.75 19.7103 22.75 20.566 22.314C21.3186 21.9305 21.9305 21.3186 22.314 20.566C22.75 19.7103 22.75 18.5902 22.75 16.35V7.65C22.75 5.40979 22.75 4.28969 22.314 3.43404C21.9305 2.68139 21.3186 2.06947 20.566 1.68597C19.7103 1.25 18.5902 1.25 16.35 1.25H13.65Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.4697 7.46973C12.7626 7.17684 13.2374 7.17684 13.5303 7.46973L17.5303 11.4697C17.8232 11.7626 17.8232 12.2375 17.5303 12.5304L13.5303 16.5304C13.2374 16.8233 12.7626 16.8233 12.4697 16.5304C12.1768 16.2375 12.1768 15.7626 12.4697 15.4697L15.1893 12.7501L2 12.7501C1.58579 12.7501 1.25 12.4143 1.25 12.0001C1.25 11.5858 1.58579 11.2501 2 11.2501L15.1893 11.2501L12.4697 8.53039C12.1768 8.2375 12.1768 7.76262 12.4697 7.46973Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
